import React, { useCallback, useEffect, useMemo, useState } from 'react'

import moment from 'moment'
import { useDispatch } from 'react-redux'
import { OpenInNew } from '@material-ui/icons'

import paths from 'src/routes/paths'
import { DrawerBodyWrapper } from '@base'
import { strings } from '@constants'
import { displayAmount } from '@utils'
import { getOverdueInvoices } from '@data'
import { showLoader } from '@data/state/action'
import Table from '@baseV2/composite/table'

import { Title, LinkText, KeyValue, KeyLabel, KeyVal, DrawerSummaryCard, SummaryRow } from '../styles'

const formatDate = (value) => (value ? moment(value).format('DD MMM YYYY') : '--')

const OverdueDetails = ({ row, reason }) => {
	const dispatch = useDispatch()
	const [invoices, setInvoices] = useState([])

	const organisationId = row?.user_details?.organisation_id
	const overdueAmount = reason?.metrics?.over_due_amount || 0

	const loadInvoices = useCallback(() => {
		if (!organisationId) return
		dispatch(showLoader(true))
		getOverdueInvoices(organisationId)
			.then((response) => setInvoices(response || []))
			.catch(() => setInvoices([]))
			.finally(() => dispatch(showLoader(false)))
	}, [dispatch, organisationId])

	useEffect(() => {
		loadInvoices()
	}, [loadInvoices])

	const openOrder = useCallback((item) => {
		if (!item?.order_id) return
		const url = `${paths.admin_manage_enquiry_order_edit_details(item?.order_id)}?invoice=${item?.transaction_id}`
		window.open(url, '_blank', 'noopener,noreferrer')
	}, [])

	const columns = useMemo(
		() => [
			{
				label: strings('invoice_number'),
				key: (item) => item,
				sortable: false,
				renderer: (item) => item?.invoice_number || '--',
			},
			{
				label: strings('invoice_amount'),
				key: (item) => displayAmount(item?.invoice_amount || 0),
				sortable: false,
			},
			{
				label: strings('due_amount'),
				key: (item) => displayAmount(item?.due_amount || 0),
				sortable: false,
			},
			{
				label: strings('due_date'),
				key: (item) => formatDate(item?.due_date),
				sortable: false,
			},
			{
				label: strings('invoice_date'),
				key: (item) => formatDate(item?.invoice_date),
				sortable: false,
			},
		],
		[]
	)

	return (
		<DrawerBodyWrapper>
			<DrawerSummaryCard>
				<Title $size='lg'>{row?.user_details?.organisation_name || '--'}</Title>
				<SummaryRow>
					<KeyValue>
						<KeyLabel>{strings('overdue_amount')}</KeyLabel>
						<KeyVal $color={overdueAmount > 0 ? 'error' : 'success'}>{displayAmount(overdueAmount)}</KeyVal>
					</KeyValue>
				</SummaryRow>
			</DrawerSummaryCard>
			<Table columns={columns} data={invoices} onRowClick={openOrder} emptyState={{ text: strings('no_data_found') }} hideFooter />
		</DrawerBodyWrapper>
	)
}

export default OverdueDetails
